// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3rBas","errorLogs":"EditorFooter_errorLogs__yuMI4"};